module.exports = __webpack_public_path__ + "static/media/BakerGreyLogo.ac27acf2.png";